/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'is-empty';
import Cookie from 'js-cookie';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import UserDashBoardSideNavigation from
  '../dashboard.components/userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from
  '../dashboard.components/userDashBoard.components/UserDashBoardTopNavigation';
import DashboardMobileNav from '../navigation.components/DashboardMobileNav';
import uploadPersonalSavingImg, { deleteUploadImg } from '../../actions/image.actions/personalSavingImg';
import uploadProfilePhoto, { deleteProfilePicError } from '../../actions/profile.actions/uploadProfileImg';
import {
  ErrorAlertNotification
} from '../commons/index';

/**
 * @class ProfilePage
 */
class ProfilePage extends Component {
  state = {
    photoUrl: ''
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @returns {*} - state
   */
  static getDerivedStateFromProps(props, state) {
    return props.savingImg !== state.photoUrl ? {
      photoUrl: props.savingImg,
    } : null;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  onChange = (event) => {
    const { errors } = this.state;
    if (errors === undefined) {
      this.setState({
        [event.target.name]: event.target.value,
      });
      return errors;
    } else if (errors[event.target.name]) {
      delete errors[event.target.name];
      this.setState({
        [event.target.name]: event.target.value,
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  /**
  *
  *@param {*} event
  *@returns {*} - state
  */
 onSubmit = (event) => {
   event.preventDefault();
   const { UploadProfilePhoto } = this.props;
   UploadProfilePhoto(this.state);
 }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  fileSelectHandler = (event) => {
    const { UploadPersonalSavingImg, savingImg } = this.props;

    this.setState({
      photoUrl: event.target.files[0]
    });
    UploadPersonalSavingImg(event.target.files[0]).then(() => {
      this.setState({ photoUrl: savingImg });
    });
  }

  onHandleDelete = () => {
    const {
      DeleteUploadImg,
      DeleteProfilePicError,
      uploadFileError,
    } = this.props;
    if (uploadFileError) {
      DeleteUploadImg();
    } else {
      DeleteProfilePicError();
    }
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      savingImg,
      imgLoading,
      uploadFileError,
      profilePhotoActionError,
      history
    } = this.props;

    const userObj = Cookie.getJSON('userObj');

    const profilePage = (
      <section className="body_space ">
        <div className="go_back">
          <span onClick={history.goBack}>
          <i className="fa fa-arrow-left" aria-hidden="true" />
          {' '}
          {'  '}
             Go Back
        </span>
        </div>
        <div className="my_account_wrapper">
          <div className="my_account">
            <div className="acct_title pl-4">
              <h3>
                My Profile
              </h3>
            </div>

            <div className="my_account_content">
              <div className="container acc_cont" id="account_sett_acct">
                {
                uploadFileError || profilePhotoActionError ? (
                  <ErrorAlertNotification
                    errors={uploadFileError || profilePhotoActionError}
                    onClick={this.onHandleDelete}
                  />
                ) : ''
              }
                <div className="row py-2">
                  <div className="col-md-5 acc_descs">

                    <h3>
                      Profile Picture
                    </h3>
                    <span>
                      update your profile picture
                    </span>

                  </div>
                  <div className="col-md-7">

                    {
                      savingImg ? (
                        <div className="">
                          <img className="kyc_doc_image" src={
                                  savingImg
                                  }
                            alt=""

                          />
                        </div>
                      ) : imgLoading
                        ? (
                          <div className="choose_file text-center">
                            <span className="image_upload">
                              <i className="fa fa-spinner fa-spin" />
                            </span>

                          </div>
                        ) : (
                          <div className="choose_file text-center">
                            <span className="image_upload">
                              <i className="fas fa-camera" />
                            </span>
                            <input
                              type="file"
                              name="img"
                              accept="image/*"
                              onChange={this.fileSelectHandler}
                            />
                          </div>
                        )
                    }

                  </div>
                </div>

                <div className="row py-2">
                  <div className="col-md-5 acc_descs">
                    <h3>
                      Full Name
                    </h3>
                    <span>
                      update your full name
                    </span>
                  </div>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="input_div">
                          <input
                            type="text"
                            name=""
                            value={userObj.firstname}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="input_div">
                          <input
                            type="text"
                            name=""
                            placeholder="Last Name"
                            value={userObj.lastname}
                            disabled

                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row py-2">
                  <div className="col-md-5 acc_descs">
                    <h3>
            Email Address
                    </h3>
                    <span>
                We send saving notifications and other account
                      {' '}
                      <br />
                      {' '}
updates to your confirmed email addres
                    </span>
                  </div>
                  <div className="col-md-7">
                    <div className="input_div">
                      <input
                        type="email"
                        name=""
                        id=""
                        placeholder="Email"
                        value={userObj.email}
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <div className="row py-2">
                  <div className="col-md-5 acc_descs">
                    <h3>
                Phone Number
                    </h3>
                    <span>
                    We send sms verification messages to your
                      {' '}
                      <br />
                      {' '}
phone number
                    </span>
                  </div>

                  <div className="col-md-7">
                    <div className="input_div">
                      <input
                        type="text"
                        name=""
                        id=""
                        placeholder="Phone Number"
                        value={userObj.phoneNumber}
                        disabled

                      />
                    </div>

                  </div>

                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="acct_btn">
                      <button
                        type="button"
                        onClick={this.onSubmit}
                      >
                        Update Account
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    );
    return (
      <>
        <DashboardMobileNav />
        <UserDashBoardSideNavigation />
        <div className="main_body_wrapper">
          <UserDashBoardTopNavigation />
          {profilePage}
        </div>
      </>
    );
  }
}

ProfilePage.propTypes = {
  DeleteUploadImg: PropTypes.func,
  DeleteProfilePicError: PropTypes.func,
  uploadFileError: PropTypes.string,
  savingImg: PropTypes.string,
  imgLoading: PropTypes.bool,
  profilePhotoActionError: PropTypes.string,
  UploadPersonalSavingImg: PropTypes.func,
};

const mapStateToProps = state => ({
  savingImg: isEmpty(state.personalSavingImage) ? '' : state.personalSavingImage.photo,
  imgLoading: state.personalSavingImage.imgLoading,
  uploadFileError: state.personalSavingImage.error,
  profilePhotoActionError: state.uploadProfilePhoto.error,
});

export default withRouter(connect(mapStateToProps, {
  UploadPersonalSavingImg: uploadPersonalSavingImg,
  UploadProfilePhoto: uploadProfilePhoto,
  DeleteUploadImg: deleteUploadImg,
  DeleteProfilePicError: deleteProfilePicError
})(ProfilePage));
